import { FC, useEffect, useState } from "react";
import { IInput } from "./Input";
import Label from "./Label";
import Switch from "./Switch";

const SwitchGroup : FC<IInput & {
  value: string | number,
  handleToggle: (value: string | number) => unknown,
  size?: 'tiny' | 'small' | 'medium' | 'large',
}> = ({
  value,
  handleToggle,
  label,
  size = 'medium',
  className,
  options = [],
  description = '',
}) => {
  const [currentValue, setCurrentValue] = useState(value);
  
  useEffect(() => {
    value !== currentValue && handleToggle(currentValue)
  }, [currentValue]);
  
  return (
    <div className={className}>      
      {!!label && (
        <Label size={size}>
          {label}
        </Label>
      )}
      <div className="flex gap-8">
        {options.map(({ title, value }) => (
          <Switch
            key={value}
            size={size}
            name="swGroup"
            value={value === currentValue}
            label={title}
            isNoLabelArea
            handleToggle={() => setCurrentValue(() => value)}
          />
        ))}
      </div>
      {!!description && <div className="text-slate-600 text-sm mt-1">{description}</div>}
    </div>
  );
}

export default SwitchGroup;
